import React, { Component } from "react";
import { connect } from "react-redux";
import { addDeliveryPriced, addPositionNewOrder, changeCountAdditives, changeCountPosition, changeSale, changeUnit, clearNewOrder, clearPromotion, deleteAdditivesNewOrder, deletePositionNewOrder } from "../../action/neworder";
import AdditivesWOKNewOrder from "./AdditivesWOKNewOrder";
import SaveNewOrderButton from "./SaveNewOrderButton";
import RobovoiceCallDownloadButton from './RobovoiceCallDownloadButton';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { roleId } from "../../constants/app";
import { setActiveModalAction } from "../../action";
import { parseNumToFixed } from "../../utils/common";
import { isEmpty } from "lodash";

class OrderPositionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputSale: '',
            openInputSale: false,
            openAdditivesWOK: false,
            openSaleDropDown: false,
            openUnitDropDown: false,
            openDescription: false,
            openDeliveryPriced: false
        };
        this.closeAdditivesWOK = this.closeAdditivesWOK.bind(this);
      }

    closeAdditivesWOK(){
        this.setState({openAdditivesWOK: false})
    }

    checkChangeCountPositionMinus(addCount) {
        if(this.props.user.role.id !== roleId.cashier || !this.props.editOrder || (addCount || 0) > 0)
            return true;
        return false
    };

    handleChangeInputSale(e){
        if(e.target.value <= 999999 && e.target.value > 0) return this.setState({inputSale: parseInt(e.target.value)})
        if(e.target.value > 999999) return this.setState({inputSale: 999999})
        if(e.target.value <= 0) return this.setState({inputSale: ''})
    };

    handleOpenPromotions() {
        this.props.setActiveModalAction({ field: 'promotionsModal', value: this.props.availablePromotions })
    }

    onClearPromotion() {
        this.props.clearPromotion();
    }

    renderPrormoCountText() {
        if (this.props.availablePromotions.length > 10 && this.props.availablePromotions.length <= 20) return 'Акций';
        const lastDigit = this.props.availablePromotions.length % 10;
        if (lastDigit === 1) return 'Акция';
        if (lastDigit > 1 && lastDigit < 5) return 'Акции';
        return 'Акций';
    };

    renderPromotions() {
        const availablePromotions = this.props.availablePromotions;
        const selectedPromotion = this.props.neworders.sale;

        if (selectedPromotion && selectedPromotion.data && selectedPromotion.code !== 'handler') {
            return (
                <div style={{ padding: '10px', borderTop: '2px solid #e0e0e4' }}>
                <div className="d-flex align-items-center flex-wrap mb-0" style={{ justifyContent: 'space-between' }}>
                    <span style={{ color: '#000' }}><span className="badge badge-danger badge-sm ms-2 px-2 py-1"> ПРОМО </span> {selectedPromotion.data.name || selectedPromotion.name}</span>
                    <button onClick={(() => {this.onClearPromotion()})} type='button' className="btn btn-sm btn-secondary"> Отменить </button>
                </div>
            </div>
            )
        }

        if (!availablePromotions || availablePromotions.length === 0 || (selectedPromotion && selectedPromotion.code === 'handler')) return null;

        return (
            <div style={{ padding: '10px', borderTop: '2px solid #e0e0e4' }}>
                <div className="d-flex align-items-center flex-wrap mb-0" style={{ justifyContent: 'space-between' }}>
                    <span style={{ color: '#000' }}>{availablePromotions.length === 1 ? 'Доступна акция' : `Доступны ${availablePromotions.length} ${this.renderPrormoCountText()}`}</span>
                    <button onClick={(() => {this.handleOpenPromotions()})} type='button' className="btn btn-sm btn-danger"> Посмотреть </button>
                </div>
            </div>
        )
    }

    renderSaleButtonTitle(sale) {
        if (!sale || !sale.data) return '%';
        if (sale.code === 'handler') {
            const salePrice = 
                sale.data.persent
                ?
                sale.data.value + '%'
                :
                +sale.data.value + ' р.';
            return salePrice;
        }
        return '%';
    }

    checkRenderInfo(item) {
        if (item.wokData) return false;
        if (item.description || item.kcal != null || item.fats != null || item.carbs != null || item.proteins != null || !isEmpty(item.equipment)) return true;
        return false;
    }

    renderInfo(item) {
        let text = '';
        if (!isEmpty(item.equipment)) {
            const { souce, ginger, wasabi} = item.equipment;
            if (souce) text+= `Соевых соусов: ${souce} шт. `
            if (ginger) text+= `Имбирь: ${ginger} гр. `
            if (wasabi) text+= `Васаби: ${wasabi} гр. `
        }
        if (item.description) text += `Состав: ${item.description}. `;
        if (item.kcal != null || item.fats != null || item.carbs != null || item.proteins != null) {
            text += 'Пищевая ценность на 100 гр.: '
            if (item.kcal != null) text+= `${item.kcal} ккал. `
            if (item.proteins != null) text+= `Белки ${item.proteins} гр. `
            if (item.fats != null) text+= `Жиры ${item.fats} гр. `
            if (item.carbs != null) text+= `Углеводы ${item.carbs} гр. `
        }

        return text;
    }

    renderName(item) {
        let name = '';
        if (item && item.equipment && item.equipment.souce) name += `${item.equipment.souce}.`
        if (item.wokData) {
            if (item.wokData.main && item.wokData.main.title) {
                name += item.wokData.main.title;
            } else {
                name += 'WOK, no title';
            }
        } else {
            if (item.data && item.data.title) {
                name += item.data.title;
            } else {
                name += item.name || 'NaN';
            }
        }

        if (item.category === this.props.settings.pizza || (item.categoryName && item.categoryName.toLowerCase() === 'пицца')) name += item.isMod ? ' 36см' : ' 30см'
        return name;
    }

    stopListCheck(goodId){
        const pointStopList = this.props.neworders.point &&
            this.props.neworders.point.stopList ?
            this.props.neworders.point.stopList.map(item => item.value) : []
        const isStop = pointStopList.includes(parseInt(goodId, 10))
        return isStop
    }

    renderGood(item) {
        return (
            <>
                <div key={item.index} className="position_list_column">
                    <div className="position_list_row">
                        <div className="position_list_position container_name"> 
                            <div className="position_list_position row_name">
                                {((item.category && item.category.id) ? item.category.id === this.props.settings.mainWok : item.wokData) &&
                                <button
                                className="order_position_list_inf_button"
                                style={{ width: '1.5rem', height: '1.5rem', fontSize: '1.5rem'}}
                                onClick={(() => this.setState({openAdditivesWOK: item.index}))}
                                onBlur={this.closeAdditivesWOK}
                                >
                                    +
                                </button>
                                }
                                <span className="position_list_position name">{this.renderName(item)}</span>
                                {this.checkRenderInfo(item) && 
                                <button 
                                className="order_position_list_inf_button"
                                onClick={(() => this.setState({openDescription : item.index}))}
                                onBlur={(() => this.setState({openDescription : false}))}
                                >
                                    i
                                </button>
                                }                                        
                            </div>
                            
                            {this.stopListCheck(item.id) && <div className="position_list_position row_name" style={{marginTop: '5px'}}>
                                    <span className="badge badge-danger badge-sm ms-2 px-2 py-1"> В СТОПЕ </span>
                                </div>}
                            {item.isPromo && <div className="position_list_position row_name" style={{marginTop: '5px'}}>                                    
                                <span className="badge badge-danger badge-sm ms-2 px-2 py-1"> ПРОМО </span>
                            </div>}
                        </div>
                        <span className="position_list_position count"> 
                            {!item.isPromo && (this.checkChangeCountPositionMinus(item.addCount)) ?
                            <button 
                            className="position_list_count_button"
                            onClick={(() => {
                                if(!item.wokData)
                                    return this.props.changeCountPosition(item.index, item.count, 'minus')
                                return this.props.changeCountAdditives(item.index, item.count, 'minus',  item.wokData.main.id, 'main')
                            })}
                            >
                                -
                            </button>
                            :
                            <span className="position_list_count_button" style={{ backgroundColor: '#f1f1f500', cursor: 'auto' }} />
                            }
                            <input
                            disabled={item.wokData ? true : false}
                            className="new_order_input count"
                            type="number"
                            value={item.count}
                            onChange={((e) => {
                                if (item.isPromo) return null;
                                if(this.checkChangeCountPositionMinus()) {
                                    if(!item.wokData)
                                        return this.props.changeCountPosition(item.index, item.count, 'handle', e.target.value)
                                    return this.props.changeCountAdditives(item.index, item.count , 'handle',  item.wokData.main.id, 'main', e.target.value)
                                } else {
                                    const minValue = item.count - (item.addCount || 0);
                                    let value = e.target.value;
                                        if(e.target.value < minValue) 
                                            value = minValue;
                                    if(!item.wokData) return this.props.changeCountPosition(item.index, item.count, 'handle', value)                                        
                                }
                            })}
                            onBlur={((e) => {
                                if (item.isPromo) return null;
                                if(this.checkChangeCountPositionMinus()) {
                                    if(parseInt(e.target.value) <= 0 || !e.target.value)
                                        return this.props.deletePositionNewOrder(item.index);
                                } else {
                                    const minValue = (item.count || 0) - (item.addCount || 0);
                                    if(parseInt(e.target.value) <= 0 || !e.target.value) {
                                        if(minValue <= 0) {
                                            return this.props.deletePositionNewOrder(item.index);
                                        } else {
                                            if(!item.wokData) return this.props.changeCountPosition(item.index, item.count, 'handle', minValue)
                                        }
                                    }
                                }
                            })}
                            />
                            {(!item.wokData && !item.isPromo) ? <button 
                            className="position_list_count_button"
                            onClick={(() => {
                                if(!item.wokData) return this.props.changeCountPosition(item.index, item.count, 'plus')
                                return this.props.changeCountAdditives(item.index, item.count , 'plus',  item.wokData.main.id, 'main')
                            })}
                            >
                                +
                            </button>
                            :
                            <span className="position_list_count_button" style={{ backgroundColor: '#f1f1f500', cursor: 'auto' }} />}
                        </span>                                    
                        {
                        !item.wokData
                        ?                                            
                            <>
                                <span className="position_list_position price">  {`${item.price} ₽`} </span>
                                <span className="position_list_position totalPrice"> {`${item.count ? item.price * item.count : ''} ₽`} </span>
                            </>
                        :
                            <>
                                <span className="position_list_position price">  {`${item.wokData.main.price} ₽`} </span>
                                <span className="position_list_position totalPrice"> {`${item.count  ? item.wokData.main.price * item.count  : ''} ₽`} </span>
                            </>
                        }
                    </div>                                
                    {this.state.openAdditivesWOK === item.index &&
                    <div className="position_list_position row_name">
                        <AdditivesWOKNewOrder index={item.index} closeAdditivesWOK={this.closeAdditivesWOK} editOrder={this.props.editOrder} user={this.props.user} count={item.count} addCount={item.addCount || 0}/>
                    </div>
                    }
                    {item.wokData && item.wokData.meat && Object.values(item.wokData.meat).map((el) => 
                    <div key={item.index + '_' + el.data.id} className="position_list_row">
                        <div className="position_list_position container_name"> 
                            <div className="position_list_position row_name">
                                <span className="position_list_position name">{'-- ' + el.data.title}</span>                                   
                            </div>
                            {this.stopListCheck(el.data.id) && <div className="position_list_position row_name" style={{marginTop: '5px'}}>
                                <span className="badge badge-danger badge-sm ms-2 px-2 py-1"> В СТОПЕ </span>
                            </div>}                                 
                        </div>
                        <span className="position_list_position count"> 
                            {(this.checkChangeCountPositionMinus(el.addCount)) && <button 
                            className="position_list_count_button"
                            onClick={(() => this.props.changeCountAdditives(item.index, el.count, 'minus',  el.data.id, 'meat'))}
                            >
                                -
                            </button> }
                            <input
                            className="new_order_input count"
                            type="number"
                            value={el.count}
                            onChange={((e) => {
                                if(this.checkChangeCountPositionMinus()) {
                                    return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.data.id, 'meat', e.target.value);
                                } else {
                                    const minValue = item.count - (item.addCount || 0);
                                    let value = e.target.value;
                                        if(e.target.value < minValue) 
                                            value = minValue;
                                    return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.data.id, 'meat', value);
                                }
                            })}
                            onBlur={((e) => {
                                if(this.checkChangeCountPositionMinus()) {
                                    if(parseInt(e.target.value) <= 0 || !e.target.value)
                                        return this.props.deleteAdditivesNewOrder(item.index, el.data.id, 'meat');
                                } else {
                                    const minValue = (item.count || 0) - (item.addCount || 0);
                                    if(parseInt(e.target.value) <= 0 || !e.target.value) {
                                        if(minValue <= 0) {
                                            return this.props.deleteAdditivesNewOrder(item.index, el.data.id, 'meat');
                                        } else {
                                            return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.data.id, 'meat', minValue);
                                        }
                                    }
                                }
                            })}
                            />
                            <button 
                            className="position_list_count_button"
                            onClick={(() => this.props.changeCountAdditives(item.index, el.count, 'plus',  el.data.id, 'meat'))}
                            >
                                +
                            </button> 
                        </span>
                        <span className="position_list_position price">  {`${el.data.price} ₽`} </span>
                        <span className="position_list_position totalPrice"> {`${el.count ? el.data.price * el.count : ''} ₽`} </span>
                    </div>
                    )}     
                    {item.wokData && item.wokData.topping && Object.values(item.wokData.topping).map((el) => 
                    <div key={item.index + '_' + el.data.id} className="position_list_row">
                        <div className="position_list_position container_name"> 
                            <div className="position_list_position row_name">
                                <span className="position_list_position name">{'-- ' + el.data.title}</span>                                   
                            </div>   
                            {this.stopListCheck(el.data.id) && <div className="position_list_position row_name" style={{marginTop: '5px'}}>
                                    <span className="badge badge-danger badge-sm ms-2 px-2 py-1"> В СТОПЕ </span>
                            </div>}                                                          
                        </div>
                        <span className="position_list_position count"> 
                            {(this.checkChangeCountPositionMinus(el.addCount)) && <button 
                            className="position_list_count_button"
                            onClick={(() => this.props.changeCountAdditives(item.index, el.count, 'minus',  el.data.id, 'topping'))}
                            >
                                -
                            </button>}
                            <input
                            className="new_order_input count"
                            type="number"
                            value={el.count}                                            
                            onChange={((e) => {
                                if(this.checkChangeCountPositionMinus()) {
                                    return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.data.id, 'topping', e.target.value);
                                } else {
                                    const minValue = item.count - (item.addCount || 0);
                                    let value = e.target.value;
                                        if(e.target.value < minValue) 
                                            value = minValue;
                                    return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.data.id, 'topping', value);
                                }
                            })}
                            onBlur={((e) => {
                                if(this.checkChangeCountPositionMinus()) {
                                    if(parseInt(e.target.value) <= 0 || !e.target.value)
                                        return this.props.deleteAdditivesNewOrder(item.index, el.data.id, 'topping');
                                } else {
                                    const minValue = (item.count || 0) - (item.addCount || 0);
                                    if(parseInt(e.target.value) <= 0 || !e.target.value) {
                                        if(minValue <= 0) {
                                            return this.props.deleteAdditivesNewOrder(item.index, el.data.id, 'topping');
                                        } else {
                                            return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.data.id, 'topping', minValue);
                                        }
                                    }
                                }
                            })}
                            />
                            <button 
                            className="position_list_count_button"
                            onClick={(() => this.props.changeCountAdditives(item.index, el.count, 'plus',  el.data.id, 'topping'))}
                            >
                                +
                            </button> 
                        </span>
                        <span className="position_list_position price">  {`${el.data.price} ₽`} </span>
                        <span className="position_list_position totalPrice"> {`${el.count ? el.data.price * el.count : ''} ₽`} </span>
                    </div>
                    )}         
                    {item.wokData && item.wokData.souce && Object.values(item.wokData.souce).map((el) => 
                    <div key={item.index + '_' + el.id} className="position_list_row">
                        <div className="position_list_position container_name"> 
                            <div className="position_list_position row_name">
                                <span className="position_list_position name">{'-- ' + el.title}</span>                                   
                            </div>                           
                            {this.stopListCheck(el.id) && <div className="position_list_position row_name" style={{marginTop: '5px'}}>
                                    <span className="badge badge-danger badge-sm ms-2 px-2 py-1"> В СТОПЕ </span>
                            </div>}                               
                        </div>
                        <span className="position_list_position count"> 
                            {(this.checkChangeCountPositionMinus(el.addCount)) && <button 
                            className="position_list_count_button"
                            onClick={(() => this.props.changeCountAdditives(item.index, (el.count || 1), 'minus',  el.id, 'souce'))}
                            >
                                -
                            </button>} 
                            <input
                            className="new_order_input count"
                            type="number"
                            value={el.count}                                            
                            onChange={((e) => {
                                if(this.checkChangeCountPositionMinus()) {
                                    return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.id, 'souce', e.target.value);
                                } else {
                                    const minValue = item.count - (item.addCount || 0);
                                    let value = e.target.value;
                                        if(e.target.value < minValue) 
                                            value = minValue;
                                    return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.id, 'souce', value);
                                }
                            })}
                            onBlur={((e) => {
                                if(this.checkChangeCountPositionMinus()) {
                                    if(parseInt(e.target.value) <= 0 || !e.target.value)
                                        return this.props.deleteAdditivesNewOrder(item.index, el.id, 'souce');
                                } else {
                                    const minValue = (item.count || 0) - (item.addCount || 0);
                                    if(parseInt(e.target.value) <= 0 || !e.target.value) {
                                        if(minValue <= 0) {
                                            return this.props.deleteAdditivesNewOrder(item.index, el.id, 'souce');
                                        } else {
                                            return this.props.changeCountAdditives(item.index, el.count, 'handle',  el.id, 'souce', minValue);
                                        }
                                    }
                                }
                            })}
                            />
                            <button 
                            className="position_list_count_button"
                            onClick={(() => this.props.changeCountAdditives(item.index, (el.count || 0), 'plus',  el.id, 'souce'))}
                            >
                                +
                            </button> 
                        </span>
                        <span className="position_list_position price">  {`${el.price} ₽`} </span>
                        <span className="position_list_position totalPrice"> {`${el.count ? el.price * el.count : '0'} ₽`} </span>
                    </div>
                    )}   
                </div>
                {this.state.openDescription === item.index &&
                <div className="position_list_row" style={{paddingLeft: '0px'}}>   
                    <div className="order_position_footer_dropdown_container description">
                        <div className="order_position_footer_dropdown description" onMouseDown={((e) => e.preventDefault())}>
                            {this.renderInfo(item)}
                        </div>
                    </div>
                </div>
                }     
            </>
        );
    };

    getChange = (payment, totalPrice, changeCash, changeSum) => {
        const сashSum = {
            no: null,
            c1000: 1000,
            c1500: 1500,
            c2000: 2000,
            c5000: 5000,
        };
        if (!payment || payment !== 'cash') return null;
        if (!totalPrice) return null;
        if (!changeCash && !changeSum) return <span style={{fontWeight: '600'}}>Без сдачи</span>
        let sum = changeSum ? parseNumToFixed(changeSum) : null;
        if (!sum) sum = сashSum[changeCash] ? сashSum[changeCash] : parseNumToFixed(changeCash.slice(1));;
        if (!parseFloat(sum)) return <span style={{fontWeight: '600'}}>Без сдачи</span>
        return <span>{'Сдача '} <span style={{fontWeight: '600'}}>{parseNumToFixed(sum - totalPrice)}</span></span>
    }

    render() {
        return(
            <>
             <div className="position_list_row head">
                    <span className="position_list_position head_name"> Наименование </span>
                    <span className="position_list_position count" style={{ justifyContent: 'center' }}> Кол-во </span>
                    <span className="position_list_position price"> Цена </span>
                    <span className="position_list_position totalPrice"> Итого </span>
                </div>
                <div className="order_position_list_body">
                    {this.props.neworders.goods && this.props.neworders.goods.map((item) => this.renderGood(item))}
                    {parseInt(this.props.neworders.unit) > 0 && parseInt(this.props.neworders.goodsPrice) !== 0 && 
                    <div className="position_list_column">
                        <div className="position_list_row">
                            <div className="position_list_position container_name"> 
                                <div className="position_list_position row_name">
                                    <span className="position_list_position name">Приборы</span>                                   
                                </div>                                
                            </div>
                            <span className="position_list_position count" style={{ justifyContent: 'center' }}> {this.props.neworders.unit} </span>
                            <span className="position_list_position price"> 0 ₽ </span>
                            <span className="position_list_position totalPrice"> 0 ₽ </span>     
                        </div>          
                    </div>      
                    }

                    {this.props.neworders.deliveryPrice > 0 && parseInt(this.props.neworders.goodsPrice) !== 0 && 
                    <div className="position_list_column">
                        <div className="position_list_row">
                            <div className="position_list_position container_name"> 
                                <div className="position_list_position row_name">
                                    <span className="position_list_position name">Доставка</span>                                   
                                </div>                                
                            </div>
                            <span className="position_list_position count" style={{ justifyContent: 'center' }}></span>
                            <span className="position_list_position price"> {`${this.props.neworders.deliveryPrice} ₽`} </span>
                            <span className="position_list_position totalPrice"> {`${this.props.neworders.deliveryPrice} ₽`} </span>     
                        </div>       
                    </div>         
                    }

                    {this.props.neworders.promocode &&
                        <div className="position_list_row totalPrice">
                            <span>Промокод</span>
                            <Link to={/promocodes/}>{this.props.neworders.promocode.name}</Link>     
                        </div>    
                    }    

                    {this.props.neworders.bonusCount > 0 &&
                    <div className="position_list_row totalPrice">
                        <span>Оплачено бонусами</span>
                        <span>{this.props.neworders.bonusCount + ' ₽'}</span>  
                    </div>
                    }
                    
                    {parseInt(this.props.neworders.goodsPrice) !== 0 && 
                        <div className="position_list_row totalPrice">
                            <span>Всего</span>
                            <span>{this.props.neworders.goodsPrice + ' ₽'}</span>       
                        </div>                
                    } 
                      
                </div>
                {this.renderPromotions()}
                <div className="order_position_list_footer">
                    {(parseInt(this.props.neworders.totalPrice) !== 0 || this.props.neworders.salePrice > 0) && 
                        <div className="position_list_row totalPrice" style={{paddingTop: '0px'}}>
                            <span>{this.props.neworders.salePrice > 0 && 'Скидка ' + this.props.neworders.salePrice} </span>
                            <span>{'К оплате '} <span style={{fontWeight: '600'}}>{this.props.neworders.totalPrice}</span></span>
                            {this.getChange(this.props.neworders.payment, this.props.neworders.totalPrice, this.props.neworders.changeCash, this.props.neworders.changeSum)}
                        </div>                
                    }      
                    {(parseInt(this.props.neworders.totalPrice) !== 0 || this.props.neworders.salePrice > 0) &&
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex" style={{ gap: '10px' }}>
                                {!this.state.openInputSale ?
                                <>
                                    <div>                                        
                                        {this.state.openSaleDropDown && 
                                        <div className="order_position_footer_dropdown_container">
                                            <div className="order_position_footer_dropdown">
                                                    <button
                                                    className={`order_position_footer_dropdown_button ${!this.props.neworders.sale && parseFloat(this.props.neworders.salePrice) === 0 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', null);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        Без скидки
                                                    </button>       
                                                    <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === 0.05 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', 5);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        -5%
                                                    </button>                                    
                                                    <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === 0.1 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', 10);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        -10%
                                                    </button>                                    
                                                    <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === 0.15 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', 15);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        -15%
                                                    </button>     
                                                    <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === 0.2 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', 20);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        -20%
                                                    </button>                                    
                                                    <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === 0.25 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', 25);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        -25%
                                                    </button>                                    
                                                    <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === 0.3 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeSale('persent', 30);
                                                        this.setState({openSaleDropDown : false});
                                                    })}
                                                    >
                                                        -30%
                                                    </button>        
                                                    {this.props.user.role.id !== roleId.cashier && <button 
                                                    className={`order_position_footer_dropdown_button ${this.props.neworders.sale === null && this.props.neworders.salePrice > 0 ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => this.setState({openInputSale: true, openSaleDropDown: false}))}
                                                    >
                                                        Суммой
                                                    </button>}                                         
                                            </div>
                                        </div>
                                        }
                                        <button 
                                            className={(this.props.neworders.sale && this.props.neworders.sale.code === 'handler') ? 'btn btn-primary btn-icon' : 'btn btn-secondary btn-icon'}
                                            style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem', width: 'auto'}}                    
                                            onClick={(() => this.setState({openSaleDropDown : !this.state.openSaleDropDown}))}
                                            onBlur={(() => this.setState({openSaleDropDown : false}))}
                                            >
                                                {this.renderSaleButtonTitle(this.props.neworders.sale)}
                                            </button>
                                        </div>
                                    <div>
                                        {this.state.openUnitDropDown &&
                                        <div className="order_position_footer_dropdown_container">
                                            <div className="order_position_footer_dropdown">                                
                                            {
                                                Array.from({length: 21}).map((_, idx) => 
                                                    <button 
                                                    key={idx}
                                                    className={`order_position_footer_dropdown_button ${(this.props.neworders.unit === idx || (this.props.neworders.unit === null && idx === 0 )) ? 'actived' : ''}`}
                                                    onMouseDown={((e) => e.preventDefault())}
                                                    onClick={(() => {
                                                        this.props.changeUnit(idx);
                                                        this.setState({openUnitDropDown : false});
                                                    })}
                                                    >
                                                        {idx > 0 ? idx : 'Без приборов'}    
                                                    </button>
                                                )
                                            }
                                            </div>
                                        </div>
                                        }
                                        <button 
                                        className='btn btn-secondary btn-icon'
                                        style={{ height: '2rem', padding: '0.15rem 0.75rem' }}                                                            
                                        onClick={(() => this.setState({openUnitDropDown: !this.state.openUnitDropDown}))}
                                        onBlur={(() => this.setState({openUnitDropDown: false}))}
                                        >
                                            <i className="flaticon-more-v2"/>
                                        </button>                                                                                
                                    </div>                                    
                                </>
                                :
                                <>
                                    <div style={{ display: 'flex', gap: '5px', width: '50%'}}>
                                        <input 
                                        className="new_order_input"
                                        style={{ width: '100%'}}
                                        type="number"
                                        placeholder="Скидка"
                                        value={this.state.inputSale}
                                        onChange={this.handleChangeInputSale.bind(this)}
                                        ref={(input) => {
                                            if(input)                            
                                              input.focus();                                            
                                        }}
                                        onBlur={(() => {
                                                this.setState({inputSale: '', openInputSale: false})
                                        })}
                                        />
                                        <button 
                                        className='btn btn-secondary btn-icon'
                                        style={{ height: '2rem', padding: '0.15rem 0.75rem' }}  
                                        onMouseDown={((e) => e.preventDefault())}
                                        onClick={(() => {
                                            if(this.state.inputSale) this.props.changeSale('handle', this.state.inputSale);    
                                            this.setState({inputSale: '', openInputSale: false});
                                        })}
                                        >
                                            <i className="flaticon2-check-mark"/>
                                        </button>
                                    </div>
                                </>
                                }
                                {this.props.neworders.zones && this.props.neworders.deliveryMethod === 'delivery' &&                           
                                    <div>
                                        {this.state.openDeliveryPriced &&
                                        <div className="order_position_footer_dropdown_container">
                                            <div className="order_position_footer_dropdown">           
                                            <button 
                                            className={`order_position_footer_dropdown_button ${this.props.neworders.deliveryPrice === 0 ? 'actived' : ''}`}
                                            onMouseDown={((e) => e.preventDefault())}
                                            onClick={(() => this.props.addDeliveryPriced(0, null))}
                                            >
                                                Бесплатная доставка    
                                            </button>                     
                                            {
                                            this.props.neworders.zones.filter((item, index, arr) => arr.findIndex(i => i.deliveryPrice === item.deliveryPrice) === index)
                                            .map((item) => (
                                            <button 
                                                key={item.deliveryCode}
                                                className={`order_position_footer_dropdown_button ${
                                                this.props.neworders.deliveryPrice === item.deliveryPrice ? 'actived' : ''
                                                }`}
                                                onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => this.props.addDeliveryPriced(item.deliveryPrice, item.deliveryCode)}
                                            >
                                                {item.deliveryPrice + ' ₽'}
                                            </button>
                                            ))
                                            }
                                            </div>
                                        </div>
                                        }
                                        <button
                                        className={this.props.neworders.deliveryPrice > 0 ? 'btn btn-primary' : 'btn btn-secondary'}
                                        style={{ height: '2rem', padding: '0.15rem 0.75rem', minWidth: '2.5rem'}}
                                        onClick={(() => this.setState({openDeliveryPriced: true}))}
                                        onBlur={(() => this.setState({openDeliveryPriced: false}))}
                                        >
                                            Доставка
                                        </button>
                                    </div>
                                }
                            </div>
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <RobovoiceCallDownloadButton />
                                {(this.checkChangeCountPositionMinus()) && <button 
                                className='btn btn-secondary btn-icon'
                                style={{ height: '2rem', padding: '0.15rem 0.75rem' }}  
                                onClick={(() => {this.props.clearNewOrder()})}
                                >
                                    <i className="flaticon2-trash"/>
                                </button>}
                                <SaveNewOrderButton editOrder={this.props.editOrder} editedOrder={this.props.editedOrder}/>
                            </div>
                        </div>
                    }
                </div>   
            </>            
        );
    }
}

const mapStateToProps = state => ({
    neworders: state.neworders,
    settings: state.settings.init.categories,
    goodsChek: state.good.list,
    user: state.user.info
});

const mapDispatchToProps = {
    changeCountPosition: (index, count, type, value) => changeCountPosition(index, count, type, value),
    deletePositionNewOrder: (id) => deletePositionNewOrder(id),
    changeUnit: (value) => changeUnit(value),
    changeSale: (type, value) => changeSale(type, value),
    clearNewOrder: () => clearNewOrder(),
    addPositionNewOrder: (good, settings) => addPositionNewOrder(good, settings),
    changeCountAdditives: (index, count, type, idAdditives, subtype, value) => changeCountAdditives(index, count, type, idAdditives, subtype, value),
    deleteAdditivesNewOrder: (index, id, subtype) => deleteAdditivesNewOrder(index, id, subtype),
    addDeliveryPriced: (price, article) => addDeliveryPriced(price, article),
    setActiveModalAction: (value) => setActiveModalAction(value),
    clearPromotion: () => clearPromotion(),
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderPositionList);